import { motion } from 'framer-motion';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { MAIN_NAVIGATION_DESKTOP_HEIGHT } from '@pkg/components/MainNavigation/styles';

const POD_NAVIGATOR_DESKTOP_VERTICAL_MARGIN = MAIN_NAVIGATION_DESKTOP_HEIGHT + 40;

export const GroupItemWrapper = styled(motion.button)<{ $isLoading?: boolean }>`
    position: relative;
    cursor: pointer;
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    display: flex;
    align-items: center;
    color: #fff;
    text-align: left;

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            pointer-events: none;
            opacity: 0.5;
        `};
`;

export const GroupItemInfo = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-left: 16px;
    opacity: 0;
    width: auto;
    font-weight: 700;
    transition: opacity 0.2s ease-out;
    pointer-events: none;

    * {
        white-space: nowrap;
    }

    ${GroupItemWrapper}:hover & {
        opacity: 1 !important;
    }
`;

export const GroupListWrapper = styled.div`
    position: relative;
    user-select: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    max-height: calc(100% - ${POD_NAVIGATOR_DESKTOP_VERTICAL_MARGIN * 2}px);
    overflow: hidden;

    &:hover ${GroupItemInfo} {
        opacity: 0.7;
        pointer-events: all !important;
    }
`;

export const GroupList = styled(ScrollContainer)`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-y: scroll;
    overscroll-behavior-y: contain;
    gap: 16px;
    padding: 16px 0 260px 0;

    mask-image: linear-gradient(0deg, transparent, black 25%, black calc(100% - 26px), transparent);

    scrollbar-width: none; // Firefox
    -ms-overflow-style: -ms-autohiding-scrollbar; // IE10+
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
        display: none;
    } // Chrome, Safari, Edge
`;

export const GroupLogoLink = styled(Link)`
    &&& {
        position: absolute;
        bottom: 40px;
        left: 40px;

        svg {
            width: 40px;
            height: 40px;
        }

        @media (min-width: ${(props) => props.theme.breakpoints.desktopSmall}) {
            left: 70px;
        }
    }
`;

export const GroupsNavigationContainer = styled(motion.div)`
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    height: 100%;
    width: 140px;
    padding-left: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    @media (min-width: ${(props) => props.theme.breakpoints.desktopSmall}) {
        padding-left: 60px;
        width: 180px;
    }
`;

export const GroupsNavigationBackdrop = styled(motion.div)`
    position: fixed;
    z-index: 8;
    left: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(90deg, rgba(9, 7, 25, 1) 25%, rgba(9, 7, 25, 0) 100%);
    pointer-events: none;
    user-select: none;
`;
